import * as React from 'react';
import Text from '../../Base/Text/Text';
import FormTitle from '../FormTitle';
import Label from '../../Base/Label/Label';
import SideFilterLabel from '../../Filter/SideFilterLabel';
import { ItemScheme } from '../MagicFormItem';

interface MagicFieldTextProps {
	itemScheme: ItemScheme;
}

const FONT_SIZE_MAP: Record<string, string> = {
	large: '16px',
	medium: '14px',
	small: '12px',
};

const MagicFieldText: React.FC<MagicFieldTextProps> = props => {
	const { itemScheme } = props;
	const { settings } = itemScheme;

	const label = itemScheme?.label || itemScheme?.title;
	let style: React.CSSProperties = {};

	if (settings?.labelStyle) {
		style = { ...settings.labelStyle };
	}

	const fontSize = FONT_SIZE_MAP[settings?.size];
	if (fontSize) {
		style.fontSize = fontSize;
	}

	if (settings?.color) {
		style.color = settings?.color;
	}

	if (!label) return <></>;

	switch (itemScheme?.subType) {
		case 'header':
			return <FormTitle tx={label} type={'default'} />;
		case 'subtitle':
			return <FormTitle tx={label} type={'subtitle'} />;
		case 'category':
			return <FormTitle tx={label} type={'category'} />;
		case 'label':
			return <Label tx={label} isOptional={settings?.isOptional} />;
		case 'filterLabel':
			return <SideFilterLabel tx={label} />;
		default:
			return <Text style={style}>{label}</Text>;
	}
};

export default MagicFieldText;
